module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return [(index !== 0) ? _c('v-divider', {
      key: index,
      attrs: {
        "inset": true
      }
    }) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
      key: item.id,
      staticClass: "list__tile--link",
      attrs: {
        "avatar": ""
      },
      on: {
        "dblclick": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.playMusic(item)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": item.al.picUrl
      }
    })]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.playMusic(item)
        },
        "dblclick": function($event) {
          $event.stopPropagation();
        }
      }
    }, [(_vm.currentMusicItem && _vm.currentMusicItem.id === item.id) ? _c('v-icon', {
      staticClass: "teal--text text--lighten-2"
    }, [_vm._v("play_circle_outline")]) : _c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("play_circle_outline")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', [_vm._v("歌手：" + _vm._s(item.ar.map(function (e) { return e.name; }).join(' / ')))]), _vm._v(" "), _c('span', {
      staticClass: "mx-3"
    }, [_vm._v("时长：" + _vm._s(_vm._f("parseDuration")(item.dt)))]), _vm._v(" "), _c('span', [_vm._v("专辑：" + _vm._s(item.al.name))])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": "",
        "ripple": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.toggleFavorite(item)
        },
        "dblclick": function($event) {
          $event.stopPropagation();
        }
      }
    }, [(item.favorited) ? _c('v-icon', {
      staticClass: "red--text"
    }, [_vm._v("favorite")]) : _c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("favorite_border")])], 1)], 1)], 1)]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4704b214","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MusicList.vue
// module id = 149
// module chunks = 1